import $ from 'jquery';
import React from 'react';

import { eventInfo, listTeaserArticleInfo, newsDate, pressReleaseInfo } from '../articleHelper';
import ArticlePresenter from '../articlePresenter';
import { ArticleImage } from './articleImage';
import CallToAction from './callToAction';

class ListTeaser extends React.Component {
  constructor() {
    super();
    this.state = {
      article: ArticlePresenter.nullArticle()
    };
  }

  componentDidMount() {
    this.ajaxArticle();
  }

  ajaxArticle() {
    const methods = [
      'title',
      'teaser',
      'public_url',
      'image_teaser',
      'report',
      'event',
      'pressrelease'
    ].join();

    $.ajax({
      url: `/api/v3/articles/${this.props.articleId}.json?methods=${methods}`,
      method: 'GET',
      success: (data) => {
        if (data !== undefined && data !== null) {
          this.setState({ article: ArticlePresenter.getIndexArticle(data) });
        }
      },
      error: (xhr, status, err) => console.error(this.props.articleId, status, err.toString())
    });
  }

  render() {
    return (
      <div className="container">
        <div className="row">
          <aside className="sidebar">&nbsp;</aside>

          <article
            className="content margin-top-md margin-bottom-xs"
            data-teaser-article-id={this.props.articleId}
          >
            <div className="row">
              <MainContent article={this.state.article} compact={this.props.compact} />
              <FurtherContent article={this.state.article} />
            </div>
          </article>

          <aside className="spacebar">&nbsp;</aside>
        </div>
      </div>
    );
  }
}

ListTeaser.propTypes = {
  articleId: React.PropTypes.number,
  compact: React.PropTypes.bool
};

function MainContent({ article, compact }) {
  if (compact) {
    return (
      <div className="col-1-of-2 main-content content-lg">
        {listTeaserArticleInfo(article)}
        {!!article.imageTeaserUrl && (
          <div className="hidden-desktop">
            <a href={article.publicUrl} title={article.title}>
              <ArticleImage imageUrl={article.imageTeaserUrl} imageAlt={article.imageTeaserAlt} />
            </a>
          </div>
        )}
      </div>
    );
  }

  const isEvent = !!article.event.id;
  const callToActionText = isEvent ? 'Jetzt anmelden' : 'Mehr erfahren';
  const callToActionCssClass = isEvent ? 'button-invert' : '';

  return (
    <div className="col-1-of-2 main-content content-lg">
      {listTeaserArticleInfo(article)}
      {!!article.imageTeaserUrl && (
        <div className="hidden-desktop">
          <a href={article.publicUrl} title={article.title}>
            <ArticleImage imageUrl={article.imageTeaserUrl} imageAlt={article.imageTeaserAlt} />
          </a>
        </div>
      )}
      <p>{article.teaser}</p>
      <CallToAction
        callToActionCssClass={callToActionCssClass}
        callToActionLink={article.publicUrl}
        callToActionText={callToActionText}
      />
    </div>
  );
}

MainContent.propTypes = {
  article: React.PropTypes.object,
  compact: React.PropTypes.bool
};

function FurtherContent({ article }) {
  return (
    <div className="col-1-of-2 further-content content-sm">
      <div className="hidden-mobile">
        <a href={article.publicUrl} title={article.title}>
          <ArticleImage imageUrl={article.imageTeaserUrl} imageAlt={article.imageTeaserAlt} />
        </a>
      </div>
    </div>
  );
}

FurtherContent.propTypes = {
  article: React.PropTypes.object
};

export default ListTeaser;



// WEBPACK FOOTER //
// ./components/listTeaser.js